import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { useContent, formatPrice } from "@/context/ContentContext";
import { resolveImage } from "@/lib/api";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const { content } = useContent();
  const discount = Math.round(((product.mrp - product.factory_price) / product.mrp) * 100);

  return (
    <div
      data-testid={`product-card-${product.product_id}`}
      className="group bg-white border border-slate-200 flex flex-col brutal-shadow-hover"
    >
      <Link to={`/products/${product.product_id}`} className="block relative aspect-square overflow-hidden bg-slate-50">
        <img
          src={resolveImage(product.image)}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {discount > 0 && (
          <div className="absolute top-0 left-0 bg-tmf-orange text-white text-[10px] font-bold uppercase tracking-widest px-2.5 py-1.5 font-mono-tmf">
            Factory · Save {discount}%
          </div>
        )}
        {product.stock <= 10 && product.stock > 0 && (
          <div className="absolute top-0 right-0 bg-tmf-navy text-white text-[10px] font-bold uppercase tracking-widest px-2.5 py-1.5 font-mono-tmf">
            Only {product.stock} left
          </div>
        )}
      </Link>

      <div className="p-4 flex flex-col flex-1 border-t border-slate-200">
        <div className="inline-flex w-fit text-[10px] font-mono-tmf uppercase tracking-widest text-tmf-blue bg-blue-50 px-2 py-1 mb-2 border border-blue-100 font-bold">
          {product.category.replace(/-/g, " ")}
        </div>
        <Link
          to={`/products/${product.product_id}`}
          className="font-display font-bold text-base leading-snug text-tmf-navy hover:text-tmf-blue line-clamp-2 min-h-[3rem]"
        >
          {product.name}
        </Link>

        <div className="mt-3 flex items-end gap-2">
          <div>
            <div className="text-[10px] font-mono-tmf uppercase text-slate-500 tracking-widest">Factory Price</div>
            <div className="font-display font-black text-xl text-tmf-navy">{formatPrice(product.factory_price, content)}</div>
          </div>
          <div className="mb-1 text-xs text-slate-400 line-through">MRP {formatPrice(product.mrp, content)}</div>
        </div>

        <div className="mt-4 flex gap-2">
          <button
            data-testid={`add-to-cart-${product.product_id}`}
            onClick={() => {
              addItem(product, 1);
              toast.success(`${product.name} added to cart`);
            }}
            className="flex-1 bg-tmf-navy hover:bg-tmf-blue text-white text-xs font-bold uppercase tracking-widest py-3 transition-colors"
          >
            Add to Cart
          </button>
          <Link
            to={`/products/${product.product_id}`}
            data-testid={`view-product-${product.product_id}`}
            className="p-3 bg-white border border-tmf-navy hover:bg-tmf-navy hover:text-white transition-colors"
            aria-label="View product"
          >
            <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
